
export enum endpointsPublic {
  // BLOG
  list_blog = 'api/blogs',

  detail_blog = 'api/blogs',

  // SYSTEM
  list_system = 'api/pages',

  detail_system = 'api/pages',
  
  create_contact='api/contacts',

  register_package='api/registers'

}
